<template>
  <section class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <div class="max-w-4xl mx-auto">
        <h2 class="text-4xl font-bold mb-6 text-gray-800">{{ $t('property.overview') }}</h2>
        <p class="text-lg text-gray-600 mb-8 leading-relaxed">
          {{ description }}
        </p>
        
        <div class="mb-12">
          <h3 class="text-2xl font-semibold mb-6 text-gray-800">{{ $t('property.features') }}</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div
              v-for="(feature, index) in features"
              :key="index"
              class="flex items-center gap-3 p-4 bg-gray-50 rounded-lg"
            >
              <svg class="w-6 h-6 text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              <span class="text-gray-700">{{ feature }}</span>
            </div>
          </div>
        </div>

        <div>
          <h3 class="text-2xl font-semibold mb-6 text-gray-800">{{ $t('property.specifications') }}</h3>
          <div class="grid grid-cols-2 gap-6">
            <div class="text-center p-6 bg-blue-50 rounded-lg">
              <div class="text-3xl font-bold text-blue-600 mb-2">{{ specifications.bedrooms }}</div>
              <div class="text-gray-600">{{ $t('property.bedrooms') }}</div>
            </div>
            <div class="text-center p-6 bg-green-50 rounded-lg">
              <div class="text-3xl font-bold text-green-600 mb-2">{{ specifications.bathrooms }}</div>
              <div class="text-gray-600">{{ $t('property.bathrooms') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  description: {
    type: String,
    required: true
  },
  features: {
    type: Array,
    required: true
  },
  specifications: {
    type: Object,
    required: true
  }
});
</script>
